/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "../styles/components/nav-bar-mobile.scss";
import Logo from "../images/marking.png";
import { ProfileDropdown } from "./dropdowns/profile-dropdown";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faChevronDown,
  faChevronUp,
  faPencil,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export const NavBarMobile = ({ me }) => {
  const location = useLocation();
  const [showMenu, setShowMenu] = React.useState(false);
  const [showLearn, setShowLearn] = React.useState(false);
  const history = useHistory();
  const [isInCrew, setIsInCrew] = useState(false);
  const [isCoach, setIsCoach] = useState(false);

  let pathName = location.pathname;
  useEffect(() => {
    if (me?.crew.length > 0) {
      setIsInCrew(true);
    } else {
      setIsInCrew(false);
    }

    const isCoachArray = me?.roles?.filter((role) => {
      return role.name === "Coach";
    });

    if (isCoachArray?.length > 0) {
      setIsCoach(true);
    }
  }, [pathName, me]);

  return (
    <div className="nav-bar__container__mobile">
      <nav className="nav-bar">
        <div className="nav-bar__brand mobile">
        <img
              className="nav-bar__logo"
              src={Logo}
              alt="Auth0 shield logo"
              style={{
                maxWidth: "100px",
              }}
            />
        </div>
        <FontAwesomeIcon
          onClick={() => {
            setShowMenu(!showMenu);
          }}
          icon={faBars}
          className="nav-bar__hamburger"
        />
      </nav>

      {showMenu && (
        <div className="nav-bar__menu__mobile">
          <nav className="nav-bar-mobile-menu">
            <div className="nav-bar__brand full">
              <NavLink to="/dashboard">
                <img
                  className="nav-bar__logo"
                  src={Logo}
                  alt="Crew Logo"
                  style={{
                    maxWidth: "100px",
                  }}
                />
              </NavLink>
            </div>
            <div className="nav-bar__links">
              <NavLink
                onClick={() => {
                  setShowMenu(false);
                }}
                isActive={() => {
                  if (
                    pathName === "/dashboard" ||
                    pathName === "/" ||
                    pathName === "/path/1/dashboard"
                  ) {
                    return true;
                  }
                  return false;
                }}
                className="link"
                to="/dashboard"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_293_355)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M16.0001 8.25333C16.026 7.92507 15.9898 7.59486 15.8934 7.28C15.587 6.74457 15.19 6.26637 14.72 5.86667C13.7267 4.94667 12.3734 4.05333 11.6267 3.33333L9.21338 1.00667C9.15338 0.953332 8.70672 0.486666 8.51338 0.339999C8.44197 0.267386 8.35189 0.215892 8.25308 0.19119C8.15428 0.166489 8.05057 0.169537 7.95338 0.199999C7.71192 0.317935 7.48763 0.468205 7.28672 0.646666C6.88672 0.999999 6.50005 1.47333 6.17338 1.76667C5.46005 2.43333 4.74672 3.04667 4.06005 3.7C3.37338 4.35333 2.68005 5.03333 2.06005 5.74667C1.65338 6.14 1.06672 6.66667 0.666716 7.15333C0.444251 7.40103 0.27014 7.68821 0.153383 8C-0.00354168 9.2289 -0.0548406 10.469 4.9244e-05 11.7067C0.00115308 12.9352 0.103724 14.1616 0.306716 15.3733C0.318787 15.413 0.341209 15.4487 0.371675 15.4768C0.40214 15.505 0.439548 15.5245 0.480049 15.5333C0.495378 15.5873 0.529107 15.6341 0.575382 15.6658C0.621658 15.6975 0.677559 15.7119 0.733383 15.7067C2.54681 15.6337 4.36288 15.6604 6.17338 15.7867C7.40672 15.8333 8.66005 15.84 9.84005 15.8267C11.1642 15.8288 12.487 15.7442 13.8001 15.5733C13.8679 15.565 13.9298 15.5302 13.9722 15.4765C14.0147 15.4229 14.0342 15.3547 14.0267 15.2867C14.0183 15.2183 13.9838 15.1558 13.9304 15.1123C13.8769 15.0688 13.8087 15.0477 13.7401 15.0533C11.9221 15.1238 10.1016 15.0948 8.28672 14.9667C7.56005 14.9667 6.82005 14.92 6.09338 14.9133C5.59338 14.9133 5.10672 14.9133 4.62005 14.9133C3.32565 14.9321 2.03392 15.0368 0.753383 15.2267C0.593121 14.0561 0.530683 12.8743 0.566716 11.6933C0.545869 10.5204 0.61944 9.34776 0.786716 8.18667C0.916982 7.89583 1.10266 7.63316 1.33338 7.41333C1.73338 7 2.23338 6.60667 2.56005 6.27333C3.08672 5.74 3.64005 5.22 4.19338 4.70667C5.06005 3.93333 5.90672 3.18 6.76005 2.42C7.09338 2.13333 7.47338 1.66667 7.87338 1.31333C7.9443 1.24771 8.02007 1.18754 8.10005 1.13333C8.30005 1.32667 8.55338 1.6 8.59338 1.64L11.0467 4C11.82 4.66667 13.1867 5.56667 14.2134 6.46C14.6254 6.79051 14.9772 7.18972 15.2534 7.64C15.3347 8.11346 15.3482 8.59608 15.2934 9.07333C15.2534 10.98 15.0334 14.04 15.14 15.58C15.1468 15.6489 15.1794 15.7128 15.2314 15.7585C15.2834 15.8043 15.3508 15.8287 15.42 15.8267C15.4551 15.825 15.4894 15.8164 15.5211 15.8014C15.5528 15.7863 15.5813 15.7652 15.6048 15.7392C15.6283 15.7132 15.6465 15.6828 15.6583 15.6498C15.67 15.6167 15.6752 15.5817 15.6734 15.5467C15.5801 13.74 16.0001 9.94667 16.0001 8.25333Z"
                      fill="#013247"
                    />
                    <path
                      d="M9.04682 14.78C9.10777 14.8304 9.18439 14.858 9.26348 14.858C9.34258 14.858 9.4192 14.8304 9.48015 14.78C9.60262 13.7626 9.65386 12.7379 9.63348 11.7133C9.65305 11.3669 9.65305 11.0197 9.63348 10.6733C9.60514 10.415 9.53536 10.1628 9.42682 9.92667C9.35594 9.80911 9.25893 9.70946 9.14332 9.63547C9.0277 9.56147 8.89658 9.51512 8.76015 9.5C8.36518 9.46958 7.96845 9.46958 7.57348 9.5C7.2077 9.4639 6.83926 9.4639 6.47348 9.5C6.26297 9.54102 6.06729 9.6377 5.90682 9.78C5.7996 9.89 5.73366 10.0337 5.72015 10.1867C5.67348 10.4733 5.49348 13.9733 5.58015 14.3C5.60035 14.3678 5.64488 14.4256 5.70518 14.4626C5.76547 14.4995 5.83729 14.5128 5.90682 14.5C6.29348 14.4267 6.33348 10.28 6.44682 10.2667C6.73348 10.2667 7.33348 10.2667 7.56682 10.2667C7.80015 10.2667 8.05348 10.2267 8.37348 10.2267C8.51745 10.2312 8.6605 10.2514 8.80015 10.2867C8.86485 10.4449 8.91831 10.6076 8.96015 10.7733C9.00765 11.0869 9.03659 11.403 9.04682 11.72C9.08015 12.3867 9.04682 12.9133 9.04682 13.5C8.98682 13.7 8.92015 14.6667 9.04682 14.78Z"
                      fill="#013247"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_293_355">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                Home
              </NavLink>

              {isInCrew && (
                <NavLink
                  isActive={() => {
                    if (pathName.includes("program")) {
                      return true;
                    }
                    return false;
                  }}
                  className="link"
                  to="/program"
                >
                  <FontAwesomeIcon icon={faUsers} /> Program Page
                </NavLink>
              )}

              <span
                onClick={() => {
                  setShowLearn(!showLearn);
                }}
                className="link"
              >
                <div className={`item ${pathName.includes("/learn/")}`}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2.96733 13.9333L2.74066 13.3333C2.56344 12.973 2.31112 12.6547 2.00066 12.4C1.82255 12.2614 1.61499 12.1656 1.394 12.12C1.434 11.5333 1.474 10.86 1.48066 10.2066C1.48066 9.69332 1.48066 9.19332 1.42733 8.75332C1.354 8.20665 1.30066 7.64665 1.18733 7.09998C1.10545 6.72108 0.982498 6.35223 0.820662 5.99998C0.812477 5.97507 0.799311 5.95209 0.781963 5.93242C0.764615 5.91276 0.743449 5.89683 0.719752 5.88561C0.696055 5.87438 0.670322 5.8681 0.644119 5.86713C0.617915 5.86616 0.591789 5.87053 0.567329 5.87998C0.542418 5.88817 0.519432 5.90133 0.49977 5.91868C0.480107 5.93603 0.464179 5.9572 0.452954 5.98089C0.441729 6.00459 0.435442 6.03032 0.434475 6.05653C0.433508 6.08273 0.437881 6.10886 0.447329 6.13332C0.534102 6.47401 0.587685 6.8223 0.607329 7.17332C0.653996 7.71998 0.607329 8.26665 0.653996 8.80665L0.887329 12.14C0.694365 12.2059 0.522036 12.3212 0.387519 12.4744C0.253001 12.6276 0.160992 12.8134 0.120662 13.0133C-0.0193874 13.8296 -0.0193874 14.6637 0.120662 15.48C0.122363 15.5098 0.129925 15.5389 0.142917 15.5658C0.155909 15.5926 0.174074 15.6167 0.196371 15.6365C0.218668 15.6563 0.244658 15.6715 0.272851 15.6813C0.301044 15.691 0.330885 15.6951 0.360662 15.6933C0.406738 15.6866 0.450338 15.6683 0.487329 15.64C0.727329 15.64 0.953996 15.6066 1.154 15.6066C1.354 15.6066 1.654 15.6066 1.894 15.6066C2.17099 15.6234 2.44899 15.6032 2.72066 15.5466C2.8507 15.5149 2.96597 15.4396 3.04733 15.3333C3.10715 15.1669 3.12769 14.989 3.10733 14.8133C3.08824 14.5163 3.04137 14.2216 2.96733 13.9333ZM1.874 15.06L0.540662 15.2267C0.516388 14.6481 0.55889 14.0688 0.667329 13.5C0.747329 13.14 0.847329 12.8333 1.14733 12.8333C1.34061 12.8533 1.51804 12.9492 1.64066 13.1C1.81698 13.2648 1.96357 13.4587 2.074 13.6733L2.274 14.1733C2.35658 14.4112 2.41466 14.6569 2.44733 14.9067C2.28733 14.8933 2.00066 15.0466 1.874 15.06ZM2.44733 15.06C2.44733 15.06 2.44733 15.04 2.44733 15.0333V15.06Z"
                      fill="white"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M15.9999 4.33998C15.9478 4.1982 15.8491 4.07832 15.7199 3.99998C15.4731 3.82891 15.2147 3.67521 14.9466 3.53998C14.5333 3.27331 14.0866 3.01998 13.6133 2.77331C12.9466 2.41331 12.2799 2.10665 11.6133 1.75331L9.33326 0.666647C9.11962 0.546707 8.89668 0.444154 8.66659 0.359981C8.5303 0.320632 8.38786 0.307066 8.24659 0.319981C8.16093 0.330838 8.07761 0.355608 7.99993 0.393314C7.89326 0.453314 7.78659 0.539981 7.71326 0.579981L6.37993 1.24665C5.67326 1.57998 4.97993 1.95331 4.29993 2.33998C3.61993 2.72665 2.96659 3.13998 2.29993 3.55331L0.299926 4.88665C0.255701 4.91654 0.224757 4.96238 0.213573 5.01457C0.202388 5.06676 0.211832 5.12126 0.239926 5.16665C0.270827 5.20978 0.317136 5.23938 0.369261 5.24931C0.421385 5.25924 0.475331 5.24874 0.519926 5.21998L2.50659 3.93998C3.17326 3.55331 3.83993 3.16665 4.50659 2.79998C5.17326 2.43331 5.89326 2.09331 6.59993 1.78665L7.93326 1.11998L8.25993 0.926647C8.34304 0.924986 8.42534 0.943275 8.49993 0.979981C8.69326 1.05331 8.87326 1.17331 9.01326 1.23998L11.2666 2.35998C11.9333 2.68665 12.5999 3.02665 13.2666 3.38665C13.6999 3.62665 14.1266 3.87331 14.5266 4.13331C14.6399 4.19998 15.0599 4.31998 15.2266 4.43331C15.1432 4.51921 15.0541 4.59939 14.9599 4.67331C14.6866 4.85998 14.3666 5.02665 14.2066 5.12665C13.6466 5.48665 13.0866 5.85331 12.5533 6.23998C12.0199 6.62665 11.4733 7.03331 10.9599 7.43998L9.62659 8.35331C9.43647 8.36394 9.24613 8.33674 9.06659 8.27331C8.53326 8.11331 7.95326 7.80665 7.54659 7.68665C7.13993 7.56665 6.57326 7.39998 6.06659 7.21998C5.55993 7.03998 5.07993 6.87998 4.66659 6.66665L3.07993 5.92665C2.75326 5.77998 2.41326 5.62665 1.99993 5.45998C1.79326 5.37998 1.57326 5.24665 1.33326 5.14665C1.22779 5.0979 1.11854 5.05777 1.00659 5.02665C0.978132 5.01865 0.948352 5.01647 0.919031 5.02024C0.88971 5.02401 0.861448 5.03365 0.835936 5.04858C0.810423 5.06352 0.788181 5.08344 0.77054 5.10716C0.752899 5.13088 0.740219 5.15792 0.733259 5.18665C0.725191 5.21554 0.722939 5.24575 0.726631 5.27551C0.730324 5.30528 0.739889 5.33402 0.754772 5.36007C0.769655 5.38611 0.78956 5.40895 0.813332 5.42724C0.837104 5.44554 0.864272 5.45893 0.893259 5.46665L1.79326 5.89998C2.19993 6.07331 2.52659 6.22665 2.84659 6.37998L3.51326 6.69998L3.63993 9.81331C3.60704 10.1458 3.60704 10.4808 3.63993 10.8133C3.67725 10.9953 3.75979 11.165 3.87993 11.3066C4.37718 11.9105 5.01941 12.3784 5.74659 12.6666C6.44172 12.9286 7.17191 13.0859 7.91326 13.1333C8.893 13.1452 9.8674 12.9873 10.7933 12.6666C11.4814 12.5034 12.114 12.1607 12.6266 11.6733C12.7179 11.4826 12.7743 11.2772 12.7933 11.0666C12.8079 10.7957 12.8079 10.5242 12.7933 10.2533C12.7933 9.87998 12.7933 9.28665 12.7266 8.68665C12.6599 8.08665 12.6399 7.50665 12.5799 7.13998L12.9533 6.87331C13.4866 6.49998 14.0266 6.13998 14.5799 5.79998C15.0191 5.58108 15.429 5.30782 15.7999 4.98665C15.8842 4.90385 15.9466 4.80142 15.9815 4.68855C16.0164 4.57568 16.0227 4.4559 15.9999 4.33998ZM12.2666 8.71331C12.2666 9.29998 12.2666 9.88665 12.2666 10.2533C12.2595 10.4986 12.2395 10.7434 12.2066 10.9866C12.1896 11.1207 12.1513 11.2513 12.0933 11.3733C12.0933 11.42 11.9666 11.46 11.8533 11.52C11.3188 11.7733 10.7575 11.9656 10.1799 12.0933C9.46997 12.2856 8.7349 12.3688 7.99993 12.34C7.31832 12.3017 6.64528 12.1693 5.99993 11.9466C5.38148 11.7328 4.82197 11.3766 4.36659 10.9066C4.28852 10.8167 4.23969 10.7051 4.22659 10.5866C4.19733 10.3322 4.18397 10.0761 4.18659 9.81998L3.91993 6.91331L4.41326 7.16665C4.76659 7.33998 5.16659 7.51331 5.58659 7.67998C6.19326 7.91331 6.83326 8.13331 7.38659 8.30665C7.78659 8.42665 8.35993 8.74665 8.88659 8.91998C9.147 9.01427 9.42318 9.05729 9.69993 9.04665C9.8654 9.00603 10.0231 8.93846 10.1666 8.84665C10.5599 8.61331 11.1666 8.17998 11.3933 8.02665C11.6199 7.87331 11.9199 7.63998 12.1799 7.45331C12.2133 7.79998 12.2333 8.25998 12.2466 8.71331H12.2666Z"
                      fill="white"
                    />
                  </svg>
                  Learn {showLearn && <FontAwesomeIcon icon={faChevronUp} />}{" "}
                  {!showLearn && <FontAwesomeIcon icon={faChevronDown} />}
                </div>
                {showLearn && (
                  <div className="dropdown">
                    <ul>
                      <li
                        className={`${pathName.includes("learn/paths")}`}
                        onClick={() => {
                          setShowMenu(false);
                          history.push("/learn/paths");
                        }}
                      >
                        <div className="line"></div>Learning Paths
                      </li>
                      <li
                        className={`${pathName.includes("learn/activities")}`}
                        onClick={() => {
                          setShowMenu(false);
                          history.push("/learn/activities");
                        }}
                      >
                        Activities
                      </li>
                    </ul>
                  </div>
                )}
              </span>
              {(isCoach || me?.admin) && (
                <NavLink
                  isActive={() => {
                    if (pathName.includes("coaching")) {
                      return true;
                    }
                    return false;
                  }}
                  className="link"
                  to="/coaching"
                >
                  <FontAwesomeIcon icon={faPencil} />{" "}
                 Coaching
                </NavLink>
              )}
              {me?.admin && (
                <NavLink to="/admin" className="link">
                  <FontAwesomeIcon icon={faUser} /> Admin
                </NavLink>
              )}
            </div>

            <ProfileDropdown />
          </nav>
        </div>
      )}
    </div>
  );
};
